import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'secondary' | 'outline' | 'ghost' | 'destructive';
  size?: 'default' | 'sm' | 'lg' | 'icon' | 'xs';
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ className, variant = 'default', size = 'default', type = 'button', ...props }, ref) => (
  <button ref={ref} type={type} className={cn(
    'inline-flex items-center justify-center rounded-lg font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#895CF6] disabled:pointer-events-none disabled:opacity-50',
    variant === 'default' && 'bg-[#895CF6] text-white hover:bg-[#7a4eeb]',
    variant === 'secondary' && 'bg-gray-200 text-gray-900 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-100',
    variant === 'outline' && 'border border-gray-300 bg-white text-gray-900 hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100',
    variant === 'ghost' && 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800',
    variant === 'destructive' && 'bg-red-600 text-white hover:bg-red-700',
    size === 'default' && 'h-10 px-4',
    size === 'sm' && 'h-10 px-3 text-sm',
    size === 'xs' && 'h-10 px-3 text-sm',
    size === 'lg' && 'h-10 px-6',
    size === 'icon' && 'h-10 w-10',
    className,
  )} {...props} />
));
Button.displayName = 'Button';
export { Button };
